import {
    Component,
    Input
} from '@angular/core';

@Component({
    selector: 'app-inventory-resource-keys',
    templateUrl: './resource-keys.component.pug',
    styleUrls: ['./resource-keys.component.less']
})
export class ResourceKeysComponent {
    @Input() data: any = {};

    constructor(
    ) {
    }
}
